import { Card } from "../../components/ui/card";
import { Skeleton } from "../../components/ui/skeleton";

export function SocialDataSkeleton({ variant = "dashboard", rows = 4 }) {
  if (variant === "list") {
    return (
      <div className="flex flex-col gap-3 py-3" aria-label="Caricamento dati social" aria-busy="true">
        {Array.from({ length: rows }).map((_, index) => (
          <Card key={index} className="overflow-hidden">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-48 bg-slate-100 px-4 py-4 space-y-3">
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-3 w-20 mt-5" />
              </div>
              <div className="flex-1 px-4 py-4 space-y-3">
                <Skeleton className="h-4 w-36" />
                <div className="flex gap-2 flex-wrap">
                  <Skeleton className="h-8 w-24 rounded-full" />
                  <Skeleton className="h-8 w-28 rounded-full" />
                  <Skeleton className="h-8 w-20 rounded-full" />
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 py-3" aria-label="Caricamento dati social" aria-busy="true">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Card key={index} className="p-4 space-y-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
            <Skeleton className="h-7 w-24" />
            <Skeleton className="h-3 w-16" />
          </Card>
        ))}
      </div>
      <Card className="overflow-hidden">
        <div className="p-4 border-b flex items-center justify-between">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-8 w-24" />
        </div>
        <div className="divide-y">
          {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className="px-4 py-4 flex items-center gap-4">
              <Skeleton className="h-10 w-10 rounded-lg shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-1/3" />
                <Skeleton className="h-3 w-2/3" />
              </div>
              <Skeleton className="h-5 w-16" />
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
